/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { mapModifiers } from 'libs/component';
import { Heading } from 'components/atoms/heading';
import Default from 'components/templates/default';
import { Section } from 'components/molecules/section';
import { VENUE_ROOM_B2, VENUE_ROOM_OPTION_LIST, VENUE_ROOM_B1, VENUE_ROOM_LG, VENUE_ROOM_1_END,VENUE_ROOM_LG_FLOOR,VENUE_ROOM_LG_END, VENUE_ROOM_LG_PHOTO,VENUE_ROOM_LM,VENUE_ROOM_G, VENUE_ROOM_G_FLOOR, VENUE_ROOM_G_END, VENUE_ROOM_G_PHOTO, VENUE_ROOM_1, VENUE_ROOM_1_FLOOR} from 'libs/constants';
import { Waypoint } from 'react-waypoint';
import { useTranslation } from 'react-i18next';
import { OptionList } from 'components/molecules/option-list';
import { useEffect } from 'react';
import { DataTable } from 'components/organisms/data-table';
import { Icon } from 'components/atoms/icon';
import numeral from 'numeral';
import { VENUE_ROOM_1_PHOTO, VENUE_ROOM_2, VENUE_ROOM_2_FLOOR, VENUE_ROOM_2_PHOTO } from 'libs/constants_room';
import { Text } from 'components/atoms/text';

export interface GlanceProps {
  currentTab?: number;
  onOptionSelected?: (tab: number) => void;
  onNewsClick?: (slug: string) => void;
}



export const Glance: React.FC<GlanceProps> = ({ currentTab: defaultCurrentTab = 0, onOptionSelected}) => {
  const { t, i18n } = useTranslation();
  const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);
  const [, setCurrentTopicIndex] = useState(0);
  // const menuRef = useRef(null);
  const policyRef = useRef(null);
  const optionList = useMemo(() => {
    return VENUE_ROOM_OPTION_LIST;
  }, []);

  useEffect(() => {
    setCurrentTab(defaultCurrentTab);
  }, [setCurrentTab, defaultCurrentTab, currentTab]);

  const handleOptionSelected = useCallback(
    (index: number) => {
      setCurrentTab(index);
      if (onOptionSelected) {
        onOptionSelected(index);
      }
    },
    [setCurrentTab, onOptionSelected]
  );

  const venue_room_B2 = useMemo(() => {
    return VENUE_ROOM_B2.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);




  const venue_room_B1 = useMemo(() => {
    return VENUE_ROOM_B1.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);


  const venue_room_LG = useMemo(() => {
    return VENUE_ROOM_LG.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_LG_end = useMemo(() => {
    return VENUE_ROOM_LG_END.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_G_end = useMemo(() => {
    return VENUE_ROOM_G_END.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_1_end = useMemo(() => {
    return VENUE_ROOM_1_END.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_LG_photo = useMemo(() => {
    return VENUE_ROOM_LG_PHOTO.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_LM = useMemo(() => {
    return VENUE_ROOM_LM.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_G = useMemo(() => {
    return VENUE_ROOM_G.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  
  const venue_room_G_photo = useMemo(() => {
    return VENUE_ROOM_G_PHOTO.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  
  const venue_room_1 = useMemo(() => {
    return VENUE_ROOM_1.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_1_photo = useMemo(() => {
    return VENUE_ROOM_1_PHOTO.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_2 = useMemo(() => {
    return VENUE_ROOM_2.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_2_photo = useMemo(() => {
    return VENUE_ROOM_2_PHOTO.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);


  const handleSectionEnter = useCallback((index: number) => {
    setCurrentTopicIndex(index);
  }, []);

  const optionItemList = optionList.map(x => (x.label as any)[i18n.language]);

  const layoutDataTableColumns = useMemo(() => {

      // No Footer
      const columns = [
        {
          Header: '场馆',
          sticky: 'left',
          line: true,
          columns: [
            {
              Header: '',
              accessor: 'facility',
              line: true,
            },
          ],
        },
        {
          Header: '尺寸（初步估算）',
          line: true,
          columns: [
            {
              Header: (
                <div className="o-data-table__header-subtitle">
                  <Icon name="all-floor" color="grey" />
                  <br />
                  长 x 宽 x 高 (m)
                </div>
              ),
              accessor: 'dimension',
              line: true,
            },
          ],
        },
        {
          Header: '可使用总面积',
          line: true,
          columns: [
            {
              Header: (
                <div className="o-data-table__header-subtitle">
                  <Icon name="square" color="grey" />
                  <br />
                  （平方米）
                </div>
              ),
              accessor: 'area_sqm',
            },
            {
              Header: (
                <div className="o-data-table__header-subtitle">
                  <Icon name="square" color="grey" />
                  <br />
                  （平方英尺）
                </div>
              ),
              accessor: 'area_sqft',
              line: true,
            },
          ],
        },
        {
          Header: '最大容量（大约）',
          columns: [
            {
              Header: (
                <div className="o-data-table__header-subtitle">
                  <Icon name="theatre" color="grey" />
                  <br />
                  剧院式
                </div>
              ),
              accessor: 'theatre',
            },
            {
              Header: (
                <div className="o-data-table__header-subtitle">
                  <Icon name="classroom" color="grey" />
                  <br />
                  课桌式
                </div>
              ),
              accessor: 'classroom',
            },
            {
              Header: (
                <div className="o-data-table__header-subtitle">
                  <Icon name="banquet" color="grey" />
                  <br />
                  宴会厅式
                </div>
              ),
              accessor: 'banquet',
            },
            {
              Header: (
                <div className="o-data-table__header-subtitle">
                  <Icon name="reception" color="grey" />
                  <br />
                  招待会
                </div>
              ),
              accessor: 'reception',
            },
            {
              Header: (
                <div className="o-data-table__header-subtitle">
                  <Icon name="booth" color="grey" />
                  <br />
                  展台(3m x 3m)
                </div>
              ),
              accessor: 'booth',
            },
          ],
        },
      ];
      return columns;
  
    return [];
  },[]);


 
  const floorPlans_LG = VENUE_ROOM_LG_FLOOR as any[];

  const layoutDisplayList_LG = floorPlans_LG?.filter(x => x.showLayout);
  const layoutDisplayList_G = VENUE_ROOM_G_FLOOR?.filter(x => x.showLayout) ;
  const layoutDisplayList_1 = VENUE_ROOM_1_FLOOR?.filter(x => x.showLayout) ;
  const layoutDisplayList_2 = VENUE_ROOM_2_FLOOR?.filter(x => x.showLayout) ;
  const layoutDataTableData_2 = useMemo(() => {
  const dataList = layoutDisplayList_2;
    return dataList?.map((item: any) => {
      let dimensionLength = 0;
      let dimensionWidth = 0;
      let dimensionHeight = 0;
      let areaSQM = 0;
      let areaSQFT = 0;
      let capTheatre = 0;
      let capClassroom = 0;
      let capBanquet = 0;
      let capReception = 0;
      let capBooth = 0;

      // dimension
      item.data.measurements.dimension.items.forEach((dim: any) => {
        if (dim.key === 'length') {
          dimensionLength = dim.value;
        }
        if (dim.key === 'width' && dimensionWidth === 0) {
          dimensionWidth = dim.value;
        }
        if (dim.key === 'height' && dimensionHeight === 0) {
          dimensionHeight = dim.value;
        }
      });
      let dimLengthFormat = '0,0';
      let dimWidthFormat = '0,0';
      let dimHeightFormat = '0,0';
      if (Number(dimensionLength.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimLengthFormat = '0,0.00';
      }
      if (Number(dimensionWidth.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimWidthFormat = '0,0.00';
      }
      if (Number(dimensionHeight.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimHeightFormat = '0,0.00';
      }
      const dimensionText = `${numeral(dimensionLength).format(dimLengthFormat)} x ${numeral(dimensionWidth).format(
        dimWidthFormat
      )} x ${numeral(dimensionHeight).format(dimHeightFormat)}`;
      // area
      item.data.measurements.area.items.forEach((area: any) => {
        if (area.key === 'area_sqm') {
          areaSQM = area.value;
        }
        if (area.key === 'area_sqft') {
          areaSQFT = area.value;
        }
      });
      // capacity
      item.data.measurements.capacity.items.forEach((cap: any) => {
        if (cap.key === 'theatre') {
          capTheatre = cap.value;
        }
        if (cap.key === 'classroom') {
          capClassroom = cap.value;
        }
        if (cap.key === 'banquet') {
          capBanquet = cap.value;
        }
        if (cap.key === 'reception') {
          capReception = cap.value;
        }
        if (cap.key === 'booth') {
          capBooth = cap.value;
        }
      });

      return {
        facility: <div className="o-data-table__cell-label">{item.label}</div>,
        dimension: dimensionText,
        area_sqm: numeral(areaSQM).format('0,0'),
        area_sqft: numeral(areaSQFT).format('0,0'),
        theatre: numeral(capTheatre).format('0,0'),
        classroom: numeral(capClassroom).format('0,0'),
        banquet: numeral(capBanquet).format('0,0'),
        reception: numeral(capReception).format('0,0'),
        booth: numeral(capBooth).format('0,0'),
      };
    });
  }, [layoutDisplayList_2]);

  const layoutDataTableData_1 = useMemo(() => {
    const dataList = layoutDisplayList_1;
    return dataList?.map((item: any) => {
      let dimensionLength = 0;
      let dimensionWidth = 0;
      let dimensionHeight = 0;
      let areaSQM = 0;
      let areaSQFT = 0;
      let capTheatre = 0;
      let capClassroom = 0;
      let capBanquet = 0;
      let capReception = 0;
      let capBooth = 0;

      // dimension
      item.data.measurements.dimension.items.forEach((dim: any) => {
        if (dim.key === 'length') {
          dimensionLength = dim.value;
        }
        if (dim.key === 'width' && dimensionWidth === 0) {
          dimensionWidth = dim.value;
        }
        if (dim.key === 'height' && dimensionHeight === 0) {
          dimensionHeight = dim.value;
        }
      });
      let dimLengthFormat = '0,0';
      let dimWidthFormat = '0,0';
      let dimHeightFormat = '0,0';
      if (Number(dimensionLength.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimLengthFormat = '0,0.00';
      }
      if (Number(dimensionWidth.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimWidthFormat = '0,0.00';
      }
      if (Number(dimensionHeight.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimHeightFormat = '0,0.00';
      }
      const dimensionText = `${numeral(dimensionLength).format(dimLengthFormat)} x ${numeral(dimensionWidth).format(
        dimWidthFormat
      )} x ${numeral(dimensionHeight).format(dimHeightFormat)}`;
      // area
      item.data.measurements.area.items.forEach((area: any) => {
        if (area.key === 'area_sqm') {
          areaSQM = area.value;
        }
        if (area.key === 'area_sqft') {
          areaSQFT = area.value;
        }
      });
      // capacity
      item.data.measurements.capacity.items.forEach((cap: any) => {
        if (cap.key === 'theatre') {
          capTheatre = cap.value;
        }
        if (cap.key === 'classroom') {
          capClassroom = cap.value;
        }
        if (cap.key === 'banquet') {
          capBanquet = cap.value;
        }
        if (cap.key === 'reception') {
          capReception = cap.value;
        }
        if (cap.key === 'booth') {
          capBooth = cap.value;
        }
      });

      return {
        facility: <div className="o-data-table__cell-label">{item.label}</div>,
        dimension: dimensionText,
        area_sqm: numeral(areaSQM).format('0,0'),
        area_sqft: numeral(areaSQFT).format('0,0'),
        theatre: numeral(capTheatre).format('0,0'),
        classroom: numeral(capClassroom).format('0,0'),
        banquet: numeral(capBanquet).format('0,0'),
        reception: numeral(capReception).format('0,0'),
        booth: numeral(capBooth).format('0,0'),
      };
    });
  }, [ layoutDisplayList_1]);


  const layoutDataTableData_LG = useMemo(() => {
    const dataList = layoutDisplayList_LG;
    return dataList?.map((item: any) => {
      let dimensionLength = 0;
      let dimensionWidth = 0;
      let dimensionHeight = 0;
      let areaSQM = 0;
      let areaSQFT = 0;
      let capTheatre = 0;
      let capClassroom = 0;
      let capBanquet = 0;
      let capReception = 0;
      let capBooth = 0;

      // dimension
      item.data.measurements.dimension.items.forEach((dim: any) => {
        if (dim.key === 'length') {
          dimensionLength = dim.value;
        }
        if (dim.key === 'width' && dimensionWidth === 0) {
          dimensionWidth = dim.value;
        }
        if (dim.key === 'height' && dimensionHeight === 0) {
          dimensionHeight = dim.value;
        }
      });
      let dimLengthFormat = '0,0';
      let dimWidthFormat = '0,0';
      let dimHeightFormat = '0,0';
      if (Number(dimensionLength.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimLengthFormat = '0,0.00';
      }
      if (Number(dimensionWidth.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimWidthFormat = '0,0.00';
      }
      if (Number(dimensionHeight.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimHeightFormat = '0,0.00';
      }
      const dimensionText = `${numeral(dimensionLength).format(dimLengthFormat)} x ${numeral(dimensionWidth).format(
        dimWidthFormat
      )} x ${numeral(dimensionHeight).format(dimHeightFormat)}`;
      // area
      item.data.measurements.area.items.forEach((area: any) => {
        if (area.key === 'area_sqm') {
          areaSQM = area.value;
        }
        if (area.key === 'area_sqft') {
          areaSQFT = area.value;
        }
      });
      // capacity
      item.data.measurements.capacity.items.forEach((cap: any) => {
        if (cap.key === 'theatre') {
          capTheatre = cap.value;
        }
        if (cap.key === 'classroom') {
          capClassroom = cap.value;
        }
        if (cap.key === 'banquet') {
          capBanquet = cap.value;
        }
        if (cap.key === 'reception') {
          capReception = cap.value;
        }
        if (cap.key === 'booth') {
          capBooth = cap.value;
        }
      });

      return {
        facility: <div className="o-data-table__cell-label">{item.label}</div>,
        dimension: dimensionText,
        area_sqm: numeral(areaSQM).format('0,0'),
        area_sqft: numeral(areaSQFT).format('0,0'),
        theatre: numeral(capTheatre).format('0,0'),
        classroom: numeral(capClassroom).format('0,0'),
        banquet: numeral(capBanquet).format('0,0'),
        reception: numeral(capReception).format('0,0'),
        booth: numeral(capBooth).format('0,0'),
      };
    });
  }, [ layoutDisplayList_LG]);

  const layoutDataTableData_G = useMemo(() => {
    const dataList = layoutDisplayList_G;
    return dataList?.map((item: any) => {
      let dimensionLength = 0;
      let dimensionWidth = 0;
      let dimensionHeight = 0;
      let areaSQM = 0;
      let areaSQFT = 0;
      let capTheatre = 0;
      let capClassroom = 0;
      let capBanquet = 0;
      let capReception = 0;
      let capBooth = 0;

      // dimension
      item.data.measurements.dimension.items.forEach((dim: any) => {
        if (dim.key === 'length') {
          dimensionLength = dim.value;
        }
        if (dim.key === 'width' && dimensionWidth === 0) {
          dimensionWidth = dim.value;
        }
        if (dim.key === 'height' && dimensionHeight === 0) {
          dimensionHeight = dim.value;
        }
      });
      let dimLengthFormat = '0,0';
      let dimWidthFormat = '0,0';
      let dimHeightFormat = '0,0';
      if (Number(dimensionLength.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimLengthFormat = '0,0.00';
      }
      if (Number(dimensionWidth.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimWidthFormat = '0,0.00';
      }
      if (Number(dimensionHeight.toFixed(2).split('.').pop()) > 0) {
        // has decimal point
        dimHeightFormat = '0,0.00';
      }
      const dimensionText = `${numeral(dimensionLength).format(dimLengthFormat)} x ${numeral(dimensionWidth).format(
        dimWidthFormat
      )} x ${numeral(dimensionHeight).format(dimHeightFormat)}`;
      // area
      item.data.measurements.area.items.forEach((area: any) => {
        if (area.key === 'area_sqm') {
          areaSQM = area.value;
        }
        if (area.key === 'area_sqft') {
          areaSQFT = area.value;
        }
      });
      // capacity
      item.data.measurements.capacity.items.forEach((cap: any) => {
        if (cap.key === 'theatre') {
          capTheatre = cap.value;
        }
        if (cap.key === 'classroom') {
          capClassroom = cap.value;
        }
        if (cap.key === 'banquet') {
          capBanquet = cap.value;
        }
        if (cap.key === 'reception') {
          capReception = cap.value;
        }
        if (cap.key === 'booth') {
          capBooth = cap.value;
        }
      });

      return {
        facility: <div className="o-data-table__cell-label">{item.label}</div>,
        dimension: dimensionText,
        area_sqm: numeral(areaSQM).format('0,0'),
        area_sqft: numeral(areaSQFT).format('0,0'),
        theatre: numeral(capTheatre).format('0,0'),
        classroom: numeral(capClassroom).format('0,0'),
        banquet: numeral(capBanquet).format('0,0'),
        reception: numeral(capReception).format('0,0'),
        booth: numeral(capBooth).format('0,0'),
      };
    });
  }, [layoutDisplayList_G]);

  
  return (
    <div className={`${mapModifiers('t-privacy-policy')} t-venue-room`}>
      <Default>
        <article className="t-privacy-policy__content">
          <Section className="t-privacy-policy__heading">
            <Heading>场地空间</Heading>
            <div className="t-venue__description">
          <Text>
            <span
              dangerouslySetInnerHTML={{
                __html: t('venue-room.description'),
              }}
            />
          </Text>
          <br />
          <Text>{t('venue-room.scroll-text')}</Text>
        </div>
          </Section>

          {/* 楼层TAB */}
          <Section className="t-media__tabs">
            <OptionList
              currentIndex={currentTab}
              modifiers="horizontal"
              items={optionItemList}
              onSelected={handleOptionSelected}
            />
          </Section>

          {/* B2层 */}
          {currentTab === 0 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {venue_room_B2.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail marginheight"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
           )}

            
      {currentTab === 1 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {venue_room_B1.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail marginheight"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
           )}

      {currentTab === 2 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {venue_room_LG.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail marginheight"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
        )}


      {currentTab === 2 && (
         <Section className={mapModifiers('t-venue-floor__info', 'layout')}>
          <div className="t-venue-floor__info-layout-data-table">
                  <DataTable
                    columns={layoutDataTableColumns}
                    data={layoutDataTableData_LG}
                  />
           </div> 
         </Section>
        )}   

        {currentTab === 2 && (
          <Section className="t-venue-floor__info-floor-data">
            <div className="t-venue-floor__info-floor-data" ref={policyRef}>
              {venue_room_LG_end.map((policy: any, index: number) => (
                <div key={index} className="t-venue-floor__info-floor-data">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-venue-floor__info-floor-data-description space"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
        )}   

        {currentTab === 2 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_LG_photo.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}     

       {currentTab === 3 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_LM.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}     

       
      {currentTab === 4 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_G.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}  

         {currentTab === 4 && (
         <Section className={mapModifiers('t-venue-floor__info', 'layout')}>
          <div className="t-venue-floor__info-layout-data-table">
                  <DataTable
                    columns={layoutDataTableColumns}
                    data={layoutDataTableData_G}
                  />
           </div> 
         </Section>
        )}   

        {currentTab === 4 && (
          <Section className="t-venue-floor__info-floor-data">
            <div className="t-venue-floor__info-floor-data" ref={policyRef}>
              {venue_room_G_end.map((policy: any, index: number) => (
                <div key={index} className="t-venue-floor__info-floor-data">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-venue-floor__info-floor-data-description space"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
        )}     

          {currentTab === 4 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_G_photo.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}      


      {currentTab === 5 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_1.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}      


      {currentTab === 5 && (
         <Section className={mapModifiers('t-venue-floor__info', 'layout')}>
          <div className="t-venue-floor__info-layout-data-table">
                  <DataTable
                    columns={layoutDataTableColumns}
                    data={layoutDataTableData_1}
                  />
           </div> 
         </Section>
        )}  
        
        {currentTab === 5 && (
          <Section className="t-venue-floor__info-floor-data">
            <div className="t-venue-floor__info-floor-data" ref={policyRef}>
              {venue_room_1_end.map((policy: any, index: number) => (
                <div key={index} className="t-venue-floor__info-floor-data">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-venue-floor__info-floor-data-description space"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
        )}   


      {currentTab === 5 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_1_photo.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}      


      {currentTab === 6 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_2.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )} 

          {currentTab === 6 && (
         <Section className={mapModifiers('t-venue-floor__info', 'layout')}>
          <div className="t-venue-floor__info-layout-data-table">
                  <DataTable
                    columns={layoutDataTableColumns}
                    data={layoutDataTableData_2}
                  />
           </div> 
         </Section>
        )}  

         {currentTab === 6 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_2_photo.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}      
     

        </article>
      </Default>
    </div>
  );
};
